(function () {
  'use strict';

  var root = document.querySelector('[id^="pg-size-guide-"]');
  if (!root) return;

  var sizes = [
    { label: '5 × 7 in', height: '7"', width: '5"' },
    { label: '8 × 10 in', height: '10"', width: '8"' },
    { label: '12 × 16 in', height: '16"', width: '12"' },
    { label: '16 × 20 in', height: '20"', width: '16"' },
    { label: '24 × 36 in', height: '36"', width: '24"' }
  ];

  var note = root.querySelector('.pg-size-guide__us-note');
  if (note) {
    note.innerHTML = '<span aria-hidden="true">🇺🇸</span> US wall art is printed in the exact US sizes shown below — not converted A sizes.';
  }

  var tables = root.querySelectorAll('details.pg-size-table');
  for (var i = 0; i < tables.length; i += 1) {
    var summary = tables[i].querySelector('summary');
    if (!summary || summary.textContent.indexOf('Poster & Framed Portrait Sizes') === -1) continue;

    var tbody = tables[i].querySelector('tbody');
    if (tbody) {
      tbody.innerHTML = sizes.map(function (size) {
        return '<tr><td>' + size.label + '</td><td>' + size.height + '</td><td>' + size.width + '</td></tr>';
      }).join('');
    }
    break;
  }

  var styleId = 'pg-us-wall-size-guide-v64';
  if (!document.getElementById(styleId)) {
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '.pg-us-wall-size-panel{padding:24px 18px 26px;background:#fff;}',
      '.pg-us-wall-size-panel__intro{margin:0 0 14px;color:#6E7480;font:600 13px/1.5 Poppins,Arial,sans-serif;text-align:center;}',
      '.pg-us-wall-size-panel__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;}',
      '.pg-us-wall-size-panel__size{display:flex;align-items:center;justify-content:center;min-height:48px;padding:10px 12px;border:1px solid #EFE7DD;border-radius:14px;background:#FAF8F5;color:#1F2A3C;font:800 14px/1.2 Poppins,Arial,sans-serif;text-align:center;}',
      '.pg-us-wall-size-panel__size:last-child:nth-child(odd){grid-column:1/-1;}',
      '@media(max-width:480px){.pg-us-wall-size-panel__grid{grid-template-columns:1fr 1fr}.pg-us-wall-size-panel__size{font-size:13px;padding:9px 8px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function replaceWallArtCard(title) {
    var cards = root.querySelectorAll('.pg-size-card');
    for (var index = 0; index < cards.length; index += 1) {
      var heading = cards[index].querySelector('h3');
      if (!heading || heading.textContent.trim() !== title) continue;

      var media = cards[index].querySelector('.pg-size-card__media');
      if (!media) return;

      var panel = document.createElement('div');
      panel.className = 'pg-us-wall-size-panel';
      panel.setAttribute('aria-label', title + ' US print sizes');

      var intro = document.createElement('p');
      intro.className = 'pg-us-wall-size-panel__intro';
      intro.textContent = 'Actual US print sizes';

      var grid = document.createElement('div');
      grid.className = 'pg-us-wall-size-panel__grid';

      sizes.forEach(function (size) {
        var item = document.createElement('span');
        item.className = 'pg-us-wall-size-panel__size';
        item.textContent = size.label;
        grid.appendChild(item);
      });

      panel.appendChild(intro);
      panel.appendChild(grid);
      media.replaceWith(panel);
      return;
    }
  }

  replaceWallArtCard('Poster');
  replaceWallArtCard('Framed Portrait');
})();
